import { render, staticRenderFns } from "./CodingEditorContainer.vue?vue&type=template&id=6dc64a32&"
import script from "./CodingEditorContainer.vue?vue&type=script&lang=js&"
export * from "./CodingEditorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports